export default {
  DESKTOP: '1440px',
  LAPTOP: '1366px',
  SM_LAPTOP: '1100px',
  TABLET: '1024px',
  PHONE: '700px',
};
